module.exports = __webpack_public_path__ + "static/media/snkrs.843b4121.mp4";